<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="记录"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
      :showReset="false"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学期名称">
          <el-select v-model="params.TermId" @change="termChange" size="mini">
            <el-option
              v-for="item in termList"
              :key="item.TermId"
              :value="item.TermId"
              :label="item.TermName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="params.Grade" size="mini" clearable @change="gradeChange">
            <el-option v-for="item in gradeList" :key="item.GradeId" :value="item.Grade"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="班级">
          <el-input size="mini" v-model="params.Class" placeholder="请填写班级" clearable />
        </el-form-item>
        <el-form-item label="班主任">
          <el-input size="mini" v-model="params.TeacherName" placeholder="请填写班主任姓名" clearable />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="SerialNumber" label="序号" width="60" align="center" />
        <el-table-column prop="Grade" label="年级" />
        <el-table-column prop="Class" label="班级" />
        <el-table-column prop="SubjectType" label="分班">
          <template slot-scope="{row}">
            <span v-if="row.SubjectType==0">无</span>
            <span v-else-if="row.SubjectType==1">理科</span>
            <span v-else-if="row.SubjectType==2">文科</span>
          </template>
        </el-table-column>
        <el-table-column prop="TeacherName" label="班主任" />
        <el-table-column prop="TermName" label="学期名称" min-width="140" />
        <el-table-column prop="CreateTime" label="创建时间" min-width="100">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.CreateTime)}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="NightAttendance" label="晚休考勤" align="center" width="100">
          <template slot-scope="{row}">
            <span v-if="row.NightAttendance==0">否</span>
            <span v-else-if="row.NightAttendance==1">是</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="NightStayAttendance" label="晚休留宿考勤" align="center" width="110">
          <template slot-scope="{row}">
            <span v-if="row.NightStayAttendance==0">否</span>
            <span v-else-if="row.NightStayAttendance==1">是</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import termApi from "@/api/ed/term";
import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  components: { list, exportDialog },
  data() {
    return {
      api: require("@/api/ed/class").default,
      gradeApi: require("@/api/ed/grade").default,
      params: {
        Class: "",
        Grade: "",
        TermId: null,
        TeacherName: "",
      },
      isMB: this.$store.state.isMB,
      termApi,
      termList: [],
      gradeList: [],
    };
  },
  beforeMount() {
    // this.prepar()
    // this.termApi.list().then(res => {
    //   this.termList = res.Data || []
    //   if(res.Data.length > 0) {
    //     this.params.TermId = res.Data[0].TermId
    //     sessionStorage.setItem("termId",res.Data[0].TermId)
    //     sessionStorage.setItem("termName",res.Data[0].TermName)
    //     sessionStorage.setItem("termNumber",res.Data[0].TermNumber)
    //     if(this.params.Grade) {
    //       this.query({ TermId: res.Data[0].TermId, Grade: this.params.Grade })
    //     }
    //   }
    // })
    // this.gradeApi.list().then(res => {
    //   this.gradeList = res.Data
    //   this.params.Grade = res.Data[0].Grade
    //   if(this.params.TermId) {
    //     this.query({ TermId: this.params.TermId, Grade: res.Data[0].Grade })
    //   }
    // })
  },
  mounted() {
    this.getTerm();
  },
  methods: {
    getTerm() {
      this.termApi.list().then((res) => {
        this.termList = res.Data || [];
        if (res.Data.length > 0) {
          this.params.TermId = res.Data[0].TermId;
          sessionStorage.setItem("termId", res.Data[0].TermId);
          sessionStorage.setItem("termName", res.Data[0].TermName);
          sessionStorage.setItem("termNumber", res.Data[0].TermNumber);
          this.getGrade();
        }
      });
    },
    getGrade() {
      this.gradeApi.list().then((res) => {
        this.gradeList = res.Data;
        // this.params.Grade = res.Data[0].Grade;
        this.query(this.params);
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
    termChange(e) {
      sessionStorage.setItem("termId", e);
      let t = this.termList.find((x) => {
        if (e == x.TermId) {
          return x;
        }
      });
      sessionStorage.setItem("termName", t.TermName);
      sessionStorage.setItem("termNumber", t.TermNumber);
      this.query({
        TermId: e,
        Grade: this.params.Grade,
        Class: this.params.Class,
        TeacherName: this.params.TeacherName,
      });
    },
    gradeChange(e) {
      this.query({
        TermId: this.params.TermId,
        Grade: e,
        Class: this.params.Class,
        TeacherName: this.params.TeacherName,
      });
    },
    export() {
      // this.$refs.exportDialog.open().then((that) => {
      //   that.getData(this.params);
      // });
      this.api.export(this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams));
    },
  },
};
</script>